import { Field } from "formik";

const CustomToggle = ({ name, checked }) => {
  return (
    <label className="inline-flex cursor-pointer mr-auto md:mr-0 ml-auto">
      <Field
        type="checkbox"
        role="switch"
        name={name}
        className="hidden peer"
        checked={checked}
      />
      <div className="w-11 h-6 relative bg-gray-700 rounded-full peer-checked:after:translate-x-full peer-checked:after:border-white  after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500"></div>
    </label>
  );
};

export default CustomToggle;
